"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateDashboardTasksQueryState = exports.dashboardTasksFieldHydrators = void 0;
const view_query_params_1 = require("../../../../common/view-query-params");
const dashboards_1 = require("../../../../store/catalogs/dashboards");
const dashboardTasksHydrationOrder = [
    view_query_params_1.ViewQueryStateField.Filter,
    view_query_params_1.ViewQueryStateField.Sort,
    view_query_params_1.ViewQueryStateField.PageSize,
];
exports.dashboardTasksFieldHydrators = {
    [view_query_params_1.ViewQueryStateField.Filter]: ({ catalogId, dispatch, state }) => {
        dispatch(dashboards_1.dashboardsActions.setPriorityTasksTableFilter(catalogId, state[view_query_params_1.ViewQueryStateField.Filter]));
    },
    [view_query_params_1.ViewQueryStateField.Sort]: ({ catalogId, dispatch, state }) => {
        dispatch(dashboards_1.dashboardsActions.setPriorityTasksTableSort(catalogId, state[view_query_params_1.ViewQueryStateField.Sort]));
    },
    [view_query_params_1.ViewQueryStateField.PageSize]: ({ catalogId, dispatch, state }) => {
        dispatch(dashboards_1.dashboardsActions.setPriorityTasksTablePageSize(catalogId, state[view_query_params_1.ViewQueryStateField.PageSize]));
    },
};
const hydrateDashboardTasksQueryState = (context) => {
    dashboardTasksHydrationOrder.forEach((field) => {
        if (field in context.state) {
            exports.dashboardTasksFieldHydrators[field](context);
        }
    });
};
exports.hydrateDashboardTasksQueryState = hydrateDashboardTasksQueryState;
